<template>
  <div>
    <!-- 导航栏 -->
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      style="background:#f2f2f2;display:flex;justify-content:center;align-items:center;"
      mode="horizontal"
      @select="handleSelect"
      router
    >
      <div style="margin-right:10px;font-size:13px;color:#999;">
        欢迎来到听说科技
      </div>
      <div style="margin:0 30px 0 10px;font-size:13px;color:#999;">
        欢迎您：{{ this.userName }}
      </div>
      <el-menu-item index="tasks" v-if="this.identity.indexOf('student') === -1"
        >任务领取</el-menu-item
      >
      <div v-if="this.identity.indexOf('student') === -1">|</div>
      <el-menu-item
        index="myTasks"
        v-if="this.identity.indexOf('student') === -1"
        >我的任务</el-menu-item
      >
      <div v-if="this.identity.indexOf('student') === -1">|</div>
      <el-menu-item index="profile">用户中心</el-menu-item>
      <div>|</div>
      <el-menu-item><span @click="clearCache()">退出</span></el-menu-item>
    </el-menu>
    <div class="page">
      <section class="dashboard-counts no-padding-bottom">
        <div class="container-fluid">
          <div class="row bg-white has-shadow">
            <!-- Item -->
            <div class="col-xl-3">
              <div class="item d-flex align-items-center">
                <div class="title">
                  <span>作文题目:</span>
                </div>
                <div class="number">
                  <strong>{{ title }}</strong>
                </div>
              </div>
            </div>
            <!-- Item -->
            <div class="col-xl-3">
              <div class="item d-flex align-items-center">
                <div class="title">
                  <span>年级:</span>
                </div>
                <div class="number">
                  <strong>{{ grade }}</strong>
                </div>
              </div>
            </div>
            <!-- Item -->
            <div class="col-xl-3">
              <div class="item d-flex align-items-center">
                <div class="title" style="width: 140px;">
                  <span>人工审核倒计时:</span>
                </div>
                <div class="number">
                  <strong id="countDown" style="font-size:25px;color:#f00;">{{
                    countDown
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6">
              <div class="pie-chart-example card">
                <div class="card-header d-flex align-items-center">
                  <h3 class="h4">原始作文图片</h3>
                </div>
                <div style="overflow:auto;">
                  <viewer :images="imageList" style="">
                    <img
                      v-for="(src, index) in imageList"
                      :key="index"
                      :src="src"
                      alt="图片加载失败"
                      style="width:86%;margin-left:7%;"
                    />
                  </viewer>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="pie-chart-example card">
                <div class="card-header d-flex align-items-center">
                  <h3 class="h4">人工识别结果</h3>
                  <div style="margin-left:30px;">
                    <el-radio disabled v-model="radio2" label="1"
                      >成功</el-radio
                    >
                    <el-radio disabled v-model="radio2" label="2"
                      >失败</el-radio
                    >
                  </div>
                </div>
                <div class="card-body">
                  <textarea
                    v-model="ruleForm.textarea"
                    cols="83"
                    rows="14"
                    style="padding:10px;overflow:auto;line-height:25px;font-size:20px;"
                    readonly="readonly"
                  ></textarea>
                  <!-- <el-form
                                        :model="ruleForm"
                                        ref="ruleForm"
                                        label-width="100px"
                                        class="demo-ruleForm"
                                        style="height:446px">
                                        <el-form-item prop="textarea">
                                            <el-input type="textarea" v-model="ruleForm.textarea" rows="14"  style="margin-left:-90px;width:110%;overflow:auto;line-height:25px;font-size:20px;"></el-input>
                                        </el-form-item>
                                    </el-form> -->
                </div>
              </div>
            </div>
          </div>
          <div style="width: 1700px;">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              style="margin: 0px 0;"
            >
              <div style="width:600px;margin:0 0 10px 65px;">
                <el-radio v-model="radio" label="0" border @change="radioChange"
                  >通过</el-radio
                >
                <el-radio v-model="radio" label="1" border @change="radioChange"
                  >不通过</el-radio
                >
                <el-switch
                  v-model="value"
                  active-color="#13ce66"
                  inactive-color="#888"
                  active-text="强制结束批改流程"
                  @change="switchChange"
                  :disabled="isAble"
                >
                </el-switch>
                <el-button
                  type="primary"
                  @click="submitForm"
                  style="width:140px;font-size:20px;margin-left:20px;"
                  >提 交</el-button
                >
              </div>
              <el-dialog
                width="30%"
                title="温馨提示"
                :visible.sync="innerVisible"
                append-to-body
                top="35vh"
              >
                <div style="margin-left:20px;font-size:15px;">
                  确认提交审核？
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handleTwoClose()">取消</el-button>
                  <el-button type="primary" @click="handleTwoTo()"
                    >确认提交</el-button
                  >
                </span>
              </el-dialog>
              <el-form-item
                prop="textarea"
                v-if="radio === '1'"
                style="margin-left:-36px;"
              >
                <el-input
                  type="textarea"
                  v-model="reasonTxt"
                  placeholder="请输入审核不通过原因"
                  rows="10"
                  style="line-height:25px;font-size:20px;"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
import axios from "axios";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
export default {
  data() {
    return {
      activeIndex: "myTasks",
      identity: "",
      userName: "",
      title: "",
      grade: "",
      radio: "0", //0---通过 1---不通过
      radio2: "1", //1---成功 2---失败
      innerVisible: false,
      ruleForm: {
        textarea: ""
      },
      value: "false",
      reasonTxt: "",
      data: {
        taskid: 0,
        resultcode: 0,
        description: "",
        terminate: 0
      },
      countDown: "", //倒计时
      imageList: [], //保存后台传过来的图片信息
      number: 0, //确定是从筛选还是代办进入该页面  0---从筛选页面进入   1---从待办事项进入
      baseUrl: "", //匹配后台地址
      receiveRes: "",
      allTime: 0, //获取后台传过来的时间
      timenow: "", //当前时间
      deadline: "", //截止时间
      terminate: 0, //是否选中‘强制结束按钮’,默认为0，勾上为1
      isAble: false
    };
  },
  created() {
    this.baseUrl = this.GLOBAL.BASE_URL;
  },
  mounted() {
    this.init();
  },
  methods: {
    // 页面初始化接口
    init() {
      if (localStorage.getItem("token")) {
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取用户信息（用户名和用户身份）
        this.identity = token.identity;
        this.userName = token.nickname;
        this.receiveRes = this.$route.query;
        this.data.taskid = this.receiveRes.id;
        let data = {
          taskid: 0,
          mode: 0
        };
        data.taskid = this.receiveRes.id;
        data.mode = this.receiveRes.mode;
        home
          .ocrReview(data)
          .then(res => {
            if (res.data && res.data.retcode === 0) {
              // this.allTime = res.data.countdown;
              this.timenow = res.data.timenow;
              this.deadline = res.data.deadline;
              this.title = res.data.title;
              this.grade = res.data.grade;
              let imageUrl = res.data.img_url; //获取后端的图片数据(是相对路径) + res.data.img_url
              this.imageList = imageUrl.split("|").map(item => {
                return this.baseUrl + item;
              });
              if (res.data.result === 0 || res.data.result === null) {
                this.radio2 = "1";
                // this.ruleForm.textarea = res.data.essay_text_raw;
              } else {
                this.radio2 = "2";
                // this.ruleForm.textarea = res.data.description;
              }
              this.ruleForm.textarea = res.data.text;
              this.timeDown();
            } else {
              alert(res.data.retmsg);
              // this.$router.push({path:'/check'});
              this.innerVisible = false;
            }
          })
          .catch(err => {
            console.log("失败", err);
          });
      } else {
        setTimeout(() => {
          alert("未登录，请进行登录");
          this.$router.push({ path: "/login" });
        }, 500);
      }
    },
    //倒计时函数
    timeDown() {
      //获得审核时限
      this.allTime = Date.parse(this.deadline) - Date.parse(this.timenow);
      if (this.allTime > 0) {
        let t1 = setInterval(() => {
          let day = Math.floor(this.allTime / (24 * 60 * 60 * 1000));
          let hour = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000) / (60 * 60 * 1000)
          );
          let minute = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000 - hour * 60 * 60 * 1000) /
              (60 * 1000)
          );
          let second = Math.floor(
            (this.allTime -
              day * 24 * 60 * 60 * 1000 -
              hour * 60 * 60 * 1000 -
              minute * 60 * 1000) /
              1000
          );
          // this.countDown = "距离任务结束还有" + ' ' + day + "天" + hour + "小时" + minute + "分" + second + "秒";
          hour = day * 24 + hour;
          if (hour < 10) {
            hour = "0" + hour;
          }
          if (minute < 10) {
            minute = "0" + minute;
          }
          if (second < 10) {
            second = "0" + second;
          }
          this.countDown = hour + " : " + minute + " : " + second;
          this.allTime -= 1000;
          // 倒计时归零时清楚定时器
          if (this.allTime === 0) {
            clearInterval(t1);
            this.countDown = "审核任务已结束";
          }
        }, 1000);
      } else {
        this.countDown = "审核任务已结束";
      }
    },
    //提交按钮
    submitForm() {
      if (this.radio === "0") {
        this.innerVisible = true;
      }
      if (this.radio === "1") {
        if (this.reasonTxt) {
          this.innerVisible = true;
        } else {
          this.$alert("请输入审核不通过的原因", {
            confirmButtonText: "确定",
            closeOnClickModal: true,
            callback: res => {}
          });
        }
      }
    },
    // 确认提交按钮点击事件
    handleTwoTo() {
      this.data.description = this.reasonTxt;
      if (this.data.resultcode === 1) {
        if (this.data.description) {
          this.submit();
        } else {
          this.$alert("请输入审核不通过的原因", {
            confirmButtonText: "确定",
            closeOnClickModal: true,
            callback: res => {
              // this.$router.push({ path: 'myTasks' });
            }
          });
        }
      } else {
        this.submit();
      }
    },
    // 提交接口
    submit() {
      home
        .ocrSubmit(this.data)
        .then(res => {
          this.innerVisible = false;
          if (res.data.retcode === 0) {
            this.$message({
              message: res.data.retmsg,
              type: "success",
              duration: 2000,
              onClose: res => {
                this.$router.push({ path: "myTasks" });
              }
            });
          } else {
            this.$message({
              message: res.data.retmsg,
              type: "warning",
              duration: 2000
            });
          }
        })
        .catch(err => {
          console.log(222, err);
        });
    },
    //取消按钮
    handleTwoClose() {
      this.innerVisible = false;
    },
    //导航栏点击事件
    handleSelect() {},
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
    // radio改变时的回调
    radioChange(val) {
      // 不通过
      if (val === "1") {
        this.data.resultcode = 1;
        // 不通过时'强制'开关禁用，并且状态为关闭
        this.value = false;
        this.isAble = true;
        // 设置页面滚动条滚动到页面最底部
        $(".page").scrollTop(10000);
      }
      // 通过
      if (val === "0") {
        this.isAble = false;
        this.data.resultcode = 0;
      }
    },
    // 开关状态改变的回调
    switchChange(val) {
      if (val === true) {
        this.$confirm("此操作将结束整个批改流程,请谨慎操作,是否确定?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
          .then(() => {
            this.value = true;
            this.data.terminate = 1;
          })
          .catch(() => {
            this.value = false;
            this.data.terminate = 0;
          });
      }
      if (val === false) {
        this.data.terminate = 0;
      }
    }
  }
};
</script>
<style scoped>
.page {
  height: 860px;
  margin: 0;
  background: #eef5f9;
  overflow: auto;
}
.no-padding-bottom {
  padding-bottom: 0;
}
section {
  padding: 20px 0;
}
.container-fluid {
  padding: 0 30px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
section.dashboard-counts .row {
  padding: 25px 15px;
  margin: 0;
}
.has-shadow {
  -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1),
    -1px 0 2px rgba(0, 0, 0, 0.05);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
}
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.col-xl-3 {
  -ms-flex: 0 0 33%;
  flex: 0 0 33%;
  max-width: 33%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.bg-white {
  background: #fff;
}
section.dashboard-counts div[class*="col-"] .item {
  border-right: 1px solid #eee;
  padding: 15px 0;
}
section.dashboard-counts div[class*="col-"]:last-of-type .item {
  border-right: none;
}
.align-items-center {
  -ms-flex-align: center;
  align-items: center;
}
.d-flex {
  display: -ms-flexbox;
  display: flex;
}
*,
::after,
::before {
  box-sizing: border-box;
}
section.dashboard-counts .title {
  font-size: 1em;
  font-weight: 300;
  color: #777;
  margin: 0 20px;
}
a,
i,
span {
  display: inline-block;
  text-decoration: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
section.dashboard-counts .number {
  font-size: 1.4em;
  font-weight: 300;
}
section.dashboard-counts .number strong {
  font-weight: 700;
}
.col-lg-6 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  height: 600px;
  background-color: #fff;
  border: 0 solid #eee;
  border-radius: 0;
  margin-bottom: 30px;
  -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1),
    -1px 0 2px rgba(0, 0, 0, 0.05);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
}
.card-header:first-child {
  border-radius: 0 0 0 0;
}
.card-header {
  padding: 1.6rem 1.25rem;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
}
.card-header .h4 {
  font-size: 1.2rem;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  color: inherit;
}
.card-body {
  padding: 1.25rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
button,
input[type="submit"] {
  cursor: pointer;
  font-family: inherit;
  font-weight: 300;
}
.btn {
  float: right;
  width: 140px;
  height: 50px;
  font-size: 1.1rem;
  letter-spacing: 0.2rem;
}
textarea {
  height: 446px;
  border-radius: 0 !important;
}
.el-form-item__content {
  margin-left: 0 !important;
}
</style>
